/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 17.11.24
 *
 */
import BaseObject from "@shared/BaseObject.js";

export default class AuthManagerLight extends BaseObject {


	constructor() {
		super();
	}

	getUserRole(){
		return null
	}

	isCoach(){
		return false
	}

	isQwoachV2App(){
		return true
	}

	getLoginPathName(){
		if(this.isCoach()){
			return "LoginCoach"
		}
		return "Login"
	}


	getUserProfile(){
		return null;
	}

	isLoggedIn(){
		return false
	}

	startListenForLoginStateChange(callback){
		callback()
		return ()=>{}

	}

}
